const { REACT_APP_CLARITY_ID } = process.env

interface ClarityConfig {
  clarityId: string
}

export const clarityConfig: ClarityConfig = {
  clarityId: REACT_APP_CLARITY_ID || '',
}
